import { paths } from "@rms-types/constants/paths";
import { lazy } from "react";

import { AppRoute } from "@/routes/types";

export const intakeRoutes: AppRoute[] = [
  {
    index: true,
    page: lazy(() => import("@/pages/intakes").then((module) => ({ default: module.Intakes }))),
    permissions: paths.app.intakes.permissions,
  },
  {
    path: paths.app.intakes.intakeDetails.path,
    page: lazy(() => import("@/pages/intakes/intakeId").then((module) => ({ default: module.IntakeDetails }))),
    permissions: paths.app.intakes.intakeDetails.permissions,
  },
];
